// extracted by mini-css-extract-plugin
module.exports = {"CancelTitle":"SubscriptionDetail_CancelTitle__3sRjF","Textarea":"SubscriptionDetail_Textarea__2t0PC"};